import { render, staticRenderFns } from "./RepresentativePhoto.vue?vue&type=template&id=695281de&scoped=true&"
import script from "./RepresentativePhoto.vue?vue&type=script&lang=js&"
export * from "./RepresentativePhoto.vue?vue&type=script&lang=js&"
import style0 from "./RepresentativePhoto.vue?vue&type=style&index=0&id=695281de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695281de",
  null
  
)

export default component.exports